<div
  class="reviewer-avatar"
  [class.reviewer-avatar--sm]="size() === 'sm'"
  [class.reviewer-avatar--md]="size() === 'md'"
  [class.reviewer-avatar--lg]="size() === 'lg'"
  [style.--avatar-hue]="hue()"
  role="img"
  [attr.aria-label]="label()">
  @if (showPhoto()) {
    <img
      class="reviewer-avatar__photo"
      [src]="photoUrl()!"
      [alt]="name()"
      loading="lazy"
      (error)="onPhotoError()" />
  } @else {
    <span class="reviewer-avatar__initials" aria-hidden="true">{{ initials() }}</span>
    <span class="reviewer-avatar__glow" aria-hidden="true"></span>
  }
</div>
